import React, { useEffect, useState } from "react";

// img
import locationIcon from "../../../assets/svg/contact/ic-location.svg";
import clockIcon from "../../../assets/svg/ic-clock.svg";

// Jds
import {
  ActionButton,
  InputDate,
  InputField,
  Container,
  Icon,
  InputDropdown,
  Notifications,
} from "@jds/core";
import CustomeTimePicker from "./customeTimePicker/CustomeTimePicker";

import {
  convertDateFormat,
  convertRailwayTimeToStandardTime,
  isValidDateRange,
  timeFormatMUI,
} from "../../../util/helper";
import useApiHttp from "../../../hooks/use-http";
import { useParams } from "react-router-dom";
import dayjs from "dayjs";
import { emptyObj, validateTextInput } from "../../../util/validation";
import useInput from "../../../hooks/use-input";
import LocationInput from "./LocationInput";
import { Label } from "@mui/icons-material";

export default function EditEventForm(props) {
  const { eventDetails, closeModal, eventRecall } = props;
  const { id: eventId } = useParams();
  const isSchoolCategory = eventDetails?.eventTypeName === "School";

  const [startDateChange, setStartDateChange] = useState(false);
  const [locationChange, setLocationChange] = useState(false);
  const [endDateChange, setEndDateChange] = useState(false);
  const [timeChange, setTimeChange] = useState(false);
  const [locationData, setLocationData] = useState({});

  const [eventTypeList, setEventTypeList] = useState([]);
  const [eventTypeSelectedIndex, setEventTypeSelectedIndex] = useState(0);
  const { sendRequest: getEventList } = useApiHttp();

  const { sendRequest: editEvent } = useApiHttp();
  const culumData = (data) => {
    setEventTypeList(data?.data?.results);
    data?.data?.results.filter((item, index) => {
      if (item.id === eventDetails?.eventType) {
        setEventTypeSelectedIndex(index);
      }
    });
  };

  const formSubmitHandler = () => {
    eventTypeBlurHandler(enteredEventName);
    eventNameBlurHandler(selectedEventType);
    startDateBlurHandler(startDate);
    endDateBlurHandler(endDate);
    locationBlurHandler(location);
    timeBlurHandler(time);
    const dateCheck =
      startDate?.replace(/-/g, "/") === endDate?.replace(/-/g, "/")
        ? timeIsValid
        : true;
    if (
      selectedEventTypeIsValid &&
      enteredEventNameIsValid &&
      startDateIsValid &&
      endDateIsValid &&
      dateCheck &&
      locationIsValid
    ) {
      const eventTypeLabel = eventTypeList.filter(
        (item) => item.id === selectedEventType,
      )[0]?.name;
      let formatTime = dayjs(time).format("HH:mm:ss");
      const formData = new FormData();
      formData.append(
        "locationLongitude",
        locationChange ? locationData?.lng : eventDetails?.locationLongitude,
      );
      formData.append(
        "locationLatitude",
        locationChange ? locationData?.lat : eventDetails?.locationLatitude,
      );
      formData.append("eventType", selectedEventType);
      formData.append("eventTypeName", eventTypeLabel);
      formData.append("name", enteredEventName);
      formData.append("startDate", convertDateFormat(startDate));
      formData.append("endDate", convertDateFormat(endDate));
      formData.append("locationName", location);
      formData.append(
        "locationState",
        locationChange ? locationData?.state : eventDetails?.locationState,
      );
      formData.append(
        "time",
        startDate?.replace(/-/g, "/") === endDate?.replace(/-/g, "/")
          ? time
          : null,
      );
      editEvent(
        {
          url: `event/update-event/${eventId}`,
          method: "PUT",
          body: formData,
          formData: true,
        },
        (data) => {
          if (data.statusCode === 200) {
            closeModal();
            eventRecall();
          }
        },
      );
    }
  };
  const {
    value: selectedEventType,
    isValid: selectedEventTypeIsValid,
    hasError: selectedEventTypeHasError,
    valueChangeHandler: eventTypeChangeHandler,
    inputBlurHandler: eventTypeBlurHandler,
    reset: resetEventTypeInput,
  } = useInput(validateTextInput, {
    type: "text",
    value: eventDetails?.eventType,
  });
  const {
    value: enteredEventName,
    isValid: enteredEventNameIsValid,
    hasError: enteredEventNameHasError,
    valueChangeHandler: eventNameChangeHandler,
    inputBlurHandler: eventNameBlurHandler,
    reset: resetEventNameInput,
  } = useInput(validateTextInput, {
    type: "text",
    value: eventDetails?.name,
  });
  const {
    value: startDate,
    isValid: startDateIsValid,
    hasError: startDateHasError,
    valueChangeHandler: startDateChangeHandler,
    inputBlurHandler: startDateBlurHandler,
    reset: resetStartDateInput,
  } = useInput(
    (dateStr) => {
      const regex = /^\d{4}[-/]\d{2}[-/]\d{2}$/;
      if (!regex.test(dateStr)) return false;
      const [yyyy, mm, dd] = dateStr
        ?.replace(/-/g, "/")
        ?.split("/")
        .map(Number);
      if (mm < 1 || mm > 12 || dd < 1 || dd > 31) return false;
      const date = new Date(yyyy, mm - 1, dd);
      return (
        date.getFullYear() === yyyy &&
        date.getMonth() === mm - 1 &&
        date.getDate() === dd
      );
    },
    {
      type: "text",
      value: eventDetails?.startDate?.replace(/-/g, "/"),
    },
  );

  const {
    value: endDate,
    isValid: endDateIsValid,
    hasError: endDateHasError,
    valueChangeHandler: endDateChangeHandler,
    inputBlurHandler: endDateBlurHandler,
    reset: resetEndDateInput,
  } = useInput(
    (dateStr) => {
      const regex = /^\d{4}[-/]\d{2}[-/]\d{2}$/;
      if (!regex.test(dateStr)) return false;
      const [yyyy, mm, dd] = dateStr
        ?.replace(/-/g, "/")
        ?.split("/")
        .map(Number);
      if (mm < 1 || mm > 12 || dd < 1 || dd > 31) return false;
      const date = new Date(yyyy, mm - 1, dd);
      return (
        date.getFullYear() === yyyy &&
        date.getMonth() === mm - 1 &&
        date.getDate() === dd
      );
    },
    {
      type: "text",
      value: eventDetails?.endDate?.replace(/-/g, "/"),
    },
  );
  const {
    value: time,
    isValid: timeIsValid,
    hasError: timeHasError,
    valueChangeHandler: timeChangeHandler,
    inputBlurHandler: timeBlurHandler,
    reset: resetTimeInput,
  } = useInput(
    (data) => {
      if (startDate?.replace(/-/g, "/") === endDate?.replace(/-/g, "/")) {
        if (data !== null && data !== "null" && data !== undefined) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    },
    {
      type: "text",
      value:
        eventDetails?.startDate === eventDetails?.endDate
          ? eventDetails?.time
          : null,
    },
  );

  const {
    value: location,
    isValid: locationIsValid,
    hasError: locationHasError,
    valueChangeHandler: locationChangeHandler,
    inputBlurHandler: locationBlurHandler,
    reset: resetLocationInput,
  } = useInput(() => true, {
    type: "text",
    value: eventDetails?.locationName,
  });

  useEffect(() => {
    getEventList(
      {
        url: `event-types/get-all`,
        method: "GET",
      },
      culumData,
    );
    console.log("hello1234==>", eventDetails?.startDate);
  }, []);

  return (
    <div className="column-form fullwidth">
      <InputDropdown
        label="Select Event Category"
        items={
          !isSchoolCategory
            ? eventTypeList
                ?.map((item) => {
                  return {
                    label: item.name,
                    value: item.id,
                  };
                })
                .filter((val) => val?.label !== "School")
            : eventTypeList?.map((item) => {
                return {
                  label: item.name,
                  value: item.id,
                };
              })
        }
        onSelect={(index, value) => {
          eventTypeChangeHandler({ target: { value: value } });
        }}
        // onClose={eventTypeBlurHandler}
        state={selectedEventTypeHasError ? "error" : "none"}
        stateConfig={{ errorText: "Please select the event type" }}
        selectedIndex={eventTypeSelectedIndex}
        disabled={isSchoolCategory}
      />
      <InputField
        label="Event Name"
        value={enteredEventName}
        onChange={(e) => {
          eventNameChangeHandler(e);
          e.stopPropagation();
        }}
        onKeyDown={(e) => {
          e.stopPropagation();
        }}
        state={enteredEventNameHasError ? "error" : "none"}
        stateConfig={{ errorText: "Please enter a valid event name!" }}
      />
      <div key={"start-date"}>
        <InputDate
          label="Event start date"
          name="start-date"
          datePicker={true}
          onChange={(value) => {
            startDateChangeHandler({ target: { value } });
            setStartDateChange(true);
            if (value?.replace(/-/g, "/") !== endDate?.replace(/-/g, "/")) {
              timeChangeHandler({
                target: { value: null },
              });
            }
            if (
              !isValidDateRange(value, endDate?.replace(/-/g, "/")) &&
              endDate
            ) {
              endDateChangeHandler({ target: { value: "" } });
              Notifications.toast.error({
                title: "End date cannot be earlier than the start date.",
                id: "event_end_date",
              });
            }
          }}
          error={startDateHasError}
          errorText="Please enter the valid date"
          value={eventDetails?.startDate}
        />
      </div>
      {/* <span style={{}}>heloo</span> */}
      <div key={"end-date"}>
        <InputDate
          label="Event end date"
          name="end-date"
          datePicker={true}
          onChange={(value) => {
            endDateChangeHandler({ target: { value } });
            setEndDateChange(true);
            if (startDate?.replace(/-/g, "/") !== value?.replace(/-/g, "/")) {
              timeChangeHandler({
                target: { value: null },
              });
            }
          }}
          error={endDateHasError}
          errorText="Please enter the valid date"
          value={endDate}
          min={startDate}
        />
      </div>
      {
        <CustomeTimePicker
          disabled={
            startDate?.replace(/-/g, "/") !== endDate?.replace(/-/g, "/")
          }
          label="Event Time"
          slotProps={{
            textField: {
              variant: "standard",
            },
            inputAdornment: {
              sx: {
                marginRight: "15px",
                marginBottom: "10px",
              },
            },
          }}
          value={timeFormatMUI(time) || null}
          // slots={{ openPickerIcon: () => <img src={clockIcon} /> }}
          slots={{
            openPickerIcon: () => (
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path
                  d="M10 0C8.02219 0 6.08879 0.58649 4.4443 1.6853C2.79981 2.78412 1.51809 4.3459 0.761209 6.17317C0.00433284 8.00043 -0.193701 10.0111 0.192152 11.9509C0.578004 13.8907 1.53041 15.6725 2.92894 17.0711C4.32746 18.4696 6.10929 19.422 8.0491 19.8079C9.98891 20.1937 11.9996 19.9957 13.8268 19.2388C15.6541 18.4819 17.2159 17.2002 18.3147 15.5557C19.4135 13.9112 20 11.9778 20 10C20 8.68678 19.7413 7.38642 19.2388 6.17317C18.7363 4.95991 17.9997 3.85752 17.0711 2.92893C16.1425 2.00035 15.0401 1.26375 13.8268 0.761205C12.6136 0.258658 11.3132 0 10 0ZM11 11C11 11.2652 10.8946 11.5196 10.7071 11.7071C10.5196 11.8946 10.2652 12 10 12H7C6.73479 12 6.48043 11.8946 6.2929 11.7071C6.10536 11.5196 6 11.2652 6 11C6 10.7348 6.10536 10.4804 6.2929 10.2929C6.48043 10.1054 6.73479 10 7 10H9V7C9 6.73478 9.10536 6.48043 9.2929 6.29289C9.48043 6.10536 9.73479 6 10 6C10.2652 6 10.5196 6.10536 10.7071 6.29289C10.8946 6.48043 11 6.73478 11 7V11Z"
                  fill="var(--color-primary-60)"
                />
              </svg>
            ),
          }}
          onChange={(value) => {
            let formatTime = dayjs(value).format("HH:mm:ss");

            timeChangeHandler({
              target: { value: convertRailwayTimeToStandardTime(formatTime) },
            });
            setTimeChange(true);
          }}
          errorMsg={timeHasError ? " Please selcet the time" : ""}
        />
      }
      <LocationInput
        value={location}
        onChange={locationChangeHandler}
        // onChange={(value) => {
        //   locationChangeHandler({ target: { value } });
        // }}
        state={locationHasError ? "error" : "none"}
        stateConfig={{ errorText: "Please enter a valid event name!" }}
        onLocationSelect={(data) => {
          setLocationChange(true);
          setLocationData(data);
          locationChangeHandler({ target: { value: data?.name } });
        }}
      />
      <Container
        fullWidth
        horizontalAlign="center"
        style={{ marginTop: "16px" }}
      >
        <ActionButton
          label="Update Event"
          onClick={() => {
            formSubmitHandler();
          }}
        />
      </Container>
    </div>
  );
}
